/** Shared date/time formatting — single source of truth.
 *
 * Timestamps are stored in UTC by the backend. These helpers render them in the
 * viewer's local timezone (browser zone). Structured so an explicit per-user
 * timezone preference can be layered in later without changing storage.
 */
export const fmtDate = (v) => {
  if (!v) return "—";
  const d = new Date(v);
  if (isNaN(d)) return v;
  return d.toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
};

export const fmtDateTime = (v) => {
  if (!v) return "—";
  const d = new Date(v);
  if (isNaN(d)) return v;
  return d.toLocaleString(undefined, {
    month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit",
  });
};

export const fmtTime = (v) => {
  if (!v) return "";
  const d = new Date(v);
  if (isNaN(d)) return "";
  return d.toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit" });
};

export const fmtWeekday = (v) => {
  if (!v) return "";
  const d = new Date(v);
  if (isNaN(d)) return "";
  return d.toLocaleDateString(undefined, { weekday: "long", month: "short", day: "numeric" });
};

/** Value for an <input type="datetime-local"> in local time. */
export const toLocalInput = (dateLike) => {
  const d = dateLike ? new Date(dateLike) : new Date();
  if (isNaN(d)) return "";
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

/** True when the ISO timestamp falls on the local calendar day of `ref`. */
export const isSameLocalDay = (iso, ref) => {
  const a = new Date(iso), b = new Date(ref);
  return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
};
